import React from 'react'
import { GenerateInvoiceFlowProvider } from './context/GenerateInvoiceFlowProvider'
import { GenerateInvoiceFlowMain } from './components/GenerateInvoiceFlowMain'

export const GenerateInvoiceFlow = () => {
  return (
    <GenerateInvoiceFlowProvider>
      <GenerateInvoiceFlowMain />
    </GenerateInvoiceFlowProvider>
  )
}
